import { RootState } from '../index';

export const selectCustomer = (state: RootState) => (state.customer.status === 'LOADED' ? state.customer.data : null);

export const selectCustomerLoadingStatus = (state: RootState) => state.customer.status;
